import {WuInput} from '@/components/input'
import {WuIcon} from '@/components/typography'
import {cn} from '@/lib/utils'
import {useEffect, useState} from 'react'

interface IWuAppHeaderSearchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onSearch: (search: string) => void
  className?: string
  defaultCollapsed?: boolean
}

export const WuAppHeaderSearch: React.FC<IWuAppHeaderSearchProps> = ({
  className,
  placeholder = 'Search surveys, folders or tools',
  defaultCollapsed = true,
  onSearch,
  ...props
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  useEffect(() => {
    setCollapsed(defaultCollapsed)
  }, [defaultCollapsed])

  return (
    <WuInput
      {...props}
      placeholder={placeholder}
      onChange={e => onSearch(e.target.value)}
      className={cn(
        'rounded-full focus-visible:outline-2 focus-visible:outline-blue-focus -outline-offset-2 bg-white',
        'transition-all duration-300 ease-in-out',
        collapsed
          ? 'w-8 px-2 text-lg rounded-full h-8 border border-white bg-transparent'
          : 'w-40 sm:w-60',
        className,
      )}
      type="search"
      Icon={
        <WuIcon
          data-testid="search-icon"
          icon="wm-search"
          className={cn(
            'text-gray-lead cursor-pointer',
            collapsed && 'text-white',
          )}
          onClick={() => setCollapsed(p => !p)}
        />
      }
    />
  )
}
